<template>
  <base-table
    title="Machines"
    item-title="Machine"
    route-name="vesselMachine"
    get-url="/byvessel"
    :headers="headers"
    :url="url"
    :item="vesselMachine"
    :item-id="vesselMachine.vesselMachineId"
    :get-id="id"
    @set-item="setItem"
  >
    <v-text-field
      v-model="vesselMachine.order"
      :rules="[rules.required, rules.integer]"
      label="Machine Order"
      required
    ></v-text-field>
    <v-text-field
      v-model="vesselMachine.name"
      :rules="[rules.required]"
      label="Vessel Machine Name"
      required
    ></v-text-field>
  </base-table>
</template>

<script>
import ObjectType from '@/services/Objects.js'
import BaseTable from '@/components/tables/BaseTable.vue'
import Validation from '@/mixins/validation.js'

export default {
  name: 'VesselMachineTable',
  components: {
    BaseTable
  },
  mixins: [Validation],
  props: {
    id: String
  },
  data() {
    return {
      headers: [
        { text: 'Order', value: 'order' },
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      vesselMachine: {
        name: '',
        vesselId: this.id,
        order: ''
      },
      url: ObjectType.VesselMachine
    }
  },
  methods: {
    setItem(item) {
      this.vesselMachine = Object.assign({}, item)
    }
  }
}
</script>

<style scoped></style>
